import {
	FETCH_PERMISSIONS_REQUEST,
	FETCH_PERMISSIONS_COMMIT,
	FETCH_PERMISSIONS_ROLLBACK,
	CLEAR_PERMISSIONS,
} from '@/actions';

const initialState = {
	byUserId: {},
	isFetched: false,
	isFetching: false,
	error: null,
};

export function permissions(state = initialState, action) {
	switch (action.type) {
		case FETCH_PERMISSIONS_REQUEST:
			return {
				...state,
				isFetching: true,
				error: null,
			};

		case FETCH_PERMISSIONS_COMMIT: {
			const { projectId, userId, permissions: userPermissions } = action.payload.userPermissions || {};

			if (!projectId || !userId || !userPermissions) {
				return {
					...state,
					isFetching: false,
					isFetched: true,
				};
			}

			const oldByUserId = state.byUserId[userId] || {};
			const oldByProjectId = oldByUserId?.byProjectId || {};

			return {
				...state,
				isFetching: false,
				isFetched: true,
				byUserId: {
					...state.byUserId,
					[userId]: {
						...oldByUserId,
						byProjectId: {
							...oldByProjectId,
							[projectId]: userPermissions,
						},
					},
				},
			};
		}

		case FETCH_PERMISSIONS_ROLLBACK:
			return {
				...state,
				isFetching: false,
				error: action.payload.error,
			};

		case CLEAR_PERMISSIONS:
			return {
				...initialState,
			};

		default:
			return state;
	}
}
